import { observable } from 'mobx';
import CountDownStore from '@src/business-components/count-down/store';
import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import { aLink } from '@src/utils/common-util';
import { $$tracker } from '@src/tracker';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

class SecondSectionStore extends BaseStore {
  constructor(props = {}) {
    super();
    Object.assign(this, { ...props });
  }

  // 页面是否展示
  @observable isActive = false;
  // 招募人数
  @observable recruitment = 0;
  toNegative = null;
  // twitch-drop
  @observable twitchDropLink = `https://www.mechabreak.com/p/zt/2024/07/25/twitch-drop/${getLanguageByPath()}/`;
  // 倒计时
  countDownStore = new CountDownStore();

  // 赛事跳转链接
  @observable competition_url;

  openCompetitionUrl() {
    aLink(this.competition_url);
  }

  clickGame = () => {
    if (this.twitchDropLink) {
      aLink(this.twitchDropLink);
    }
    $$tracker.clickTD();
  };

  use() {
    super.use();

    useMount(() => {
      // this.$ztService.getCountdownMsg().then(res => {
      //   this.countDownStore.totalSeconds = res.countdown;
      //   this.countDownStore.countdownMultiplier = res.countdown_doubling;
      //   this.countDownStore.isStart = true;
      // });
    });
  }
}

export default SecondSectionStore;
